module.exports = __webpack_public_path__ + "static/media/developer_img_1.99a2048d.svg";